// filepath: /Users/thomasgaggl/Softline/development/nx/libs/framework/core/src/lib/date/functions/manupulation/start-of/start-of-minute.function.ts
import { IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { constructDate } from '../../helper/construct-date.function';

/**
 * Returns the start of the minute for the given ISO input.
 * - For date-time without tz (YYYY-MM-DDTHH:mm:ss[.fraction]) -> 'YYYY-MM-DDTHH:mm:00.000'
 * - For date-time with tz (YYYY-MM-DDTHH:mm:ss[.fraction](Z|±HH:MM)) -> 'YYYY-MM-DDTHH:mm:00.000Z|±HH:MM'
 * Throws for date-only inputs (YYYY-MM-DD) and invalid formats.
 */
export function startOfMinute<T extends IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'dateTime'
    && deconstructed._type !== 'dateTimeTz'
    && deconstructed._type !== 'time'
    && deconstructed._type !== 'timeTz') {
    throw new Error('startOfMinute: invalid ISO date/time string');
  }
  deconstructed.seconds = 0;
  deconstructed.milliseconds = 0;
  return constructDate(deconstructed) as unknown as T;
}

// Backwards-compatible alias
export { startOfMinute as startOfMinuteFunction };
